
  <div id="content" class="main-content">
     <div class="container">
        <div class="col-12 pl-0">
           <div class="crumbs breadcrumbs-style-2">
              <ul class="breadcrumb">
                 <li class="mt-3"><a href="dashboard" routerLink="/dashboard"><i class="flaticon-home-fill"></i></a>
                 </li>
                 <li class="mt-3"><a href="contacts" routerLink="/contacts">Contacts</a></li>
                 <li class="active mt-3 current_arian"><a href="javascript:void(0);" class="current_arian">Fiche contact</a></li>
              </ul>
           </div>
        </div>
       <div class="page-header">
          <div class="page-title mt-3 row col-lg-12 col-md-12 d-flex justify-content-between">
             <h1>Détails du Contact : <b>{{contact?.fullName}}</b></h1>
          </div>
       </div>
        <div class="layout-spacing">
                <div class="page-container01">
                  <div class="page-container02">
                    <h3 class="page-text">
                      <span>Informations du contact</span>
                      <br />
                    </h3>
                    <div *ngIf="retrieveContactLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                    <div class="page-container03" *ngIf="!retrieveContactLoader">
                      <div class="page-container04">
                        <div class="page-container05">
                          <div class="page-container06">
                            <h4 class="page-text03">Nom</h4>
                            <div class="page-container07">
                              <span class="page-text04" *ngIf="contact.lastName != null && contact.lastName != ''">{{contact?.lastName}}</span>
                              <span class="page-text04" *ngIf="contact.lastName == null && contact.lastName == ''">----</span>
                            </div>
                          </div>
                          <div class="page-container08">
                            <h4 class="page-text05">Prénom</h4>
                            <div class="page-container09">
                              <span class="page-text06" *ngIf="contact.firstName != null && contact.firstName != ''">{{contact?.firstName}}</span>
                              <span class="page-text06" *ngIf="contact.firstName == null && contact.firstName == ''">----</span>
                            </div>
                          </div>
                        </div>
                        <div class="page-container10">
                          <div class="page-container11">
                            <h4 class="page-text07">Adresse e-mail</h4>
                            <div class="page-container12">
                              <span class="page-text08" *ngIf="contact.emailAddress != null && contact.emailAddress != ''">{{contact?.emailAddress}}</span>
                              <span class="page-text08" *ngIf="contact.emailAddress == null || contact.emailAddress == ''">----</span>
                            </div>
                          </div>
                          <div class="page-container13">
                            <h4 class="page-text09">Téléphone (mobile)</h4>
                            <div class="page-container14">
                              <span class="page-text10" *ngIf="contact.mobilePhone != null && contact.mobilePhone != ''">{{contact?.mobilePhone}}</span>
                              <span class="page-text10" *ngIf="contact.mobilePhone == null || contact.mobilePhone == ''">----</span>
                            </div>
                          </div>
                        </div>                        
                      </div>
                      <div class="page-container15">
                        <div class="page-container16">
                          <div class="page-container17">
                            <h4 class="page-text11">Téléphone (domicile)</h4>
                            <div class="page-container18">
                              <span class="page-text12" *ngIf="contact.homePhone != null && contact.homePhone != ''">{{contact?.homePhone}}</span>
                              <span class="page-text12" *ngIf="contact.homePhone == null || contact.homePhone == ''">----</span>
                            </div>
                          </div>
                          <div class="page-container19">
                            <h4 class="page-text13">Nom du compte</h4>
                            <div class="page-container20" *ngIf="contact.customerUuid == null">
                                <span class="page-text14" *ngIf="contact.accountName != null && contact.accountName != ''">{{contact?.accountName}}</span>
                                <span class="page-text14" *ngIf="contact.accountName == null || contact.accountName == ''">----</span>
                            </div>
                            <div class="page-container20" *ngIf="contact.customerUuid != null">
                                <a [attr.href]="'/customer/fromshow;cs='+contact?.customerUuid" class="mr-2 action_plan_unique accountName page-text14">
                                    {{ contact.accountName }}
                                </a>
                          </div>
                          </div>
                        </div>
                        <div class="page-container21">
                          <div class="page-container22">
                            <h4 class="page-text15">Service du contact</h4>
                            <div class="page-container23">
                              <span class="page-text16" *ngIf="contact.contactService != null && contact.contactService != ''">{{contact?.contactService}}</span>
                              <span class="page-text16" *ngIf="contact.contactService == null || contact.contactService == ''">----</span>
                            </div>
                          </div>
                          <div class="page-container24">
                            <h4 class="page-text17">Fonction du contact</h4>
                            <div class="page-container25">
                              <span class="page-text18" *ngIf="contact.contactFunction != null && contact.contactFunction != ''">{{contact?.contactFunction}}</span>
                              <span class="page-text18" *ngIf="contact.contactFunction == null || contact.contactFunction == ''">----</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="page-container26">
                  <div class="page-container27">
                    <h3 class="page-text19">
                      <span>Adresses</span>
                      <br />
                    </h3>
                    <div *ngIf="retrieveContactLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                    <div class="page-container28" *ngIf="!retrieveContactLoader">
                      <div class="page-container29">
                        <div class="page-container30">
                          <div class="page-container31">
                            <h4 class="page-text22">
                              <span>Adresse personnelle</span>
                              <br />
                            </h4>
                            <div class="page-container32">
                              <span class="page-text25" *ngIf="contact?.personalAddress !== null && contact?.personalAddress !== ''">{{contact?.personalAddress}}</span>
                              <span class="page-text25" *ngIf="contact?.personalAddress === null || contact?.personalAddress === ''">----</span>
                            </div>
                          </div>
                          <div class="page-container33">
                            <h4 class="page-text26">Adresse additionnelle</h4>
                            <div class="page-container34">
                              <span class="page-text27" *ngIf="contact?.additionalAddress !== null && contact?.additionalAddress !== ''">{{contact?.additionalAddress}}</span>
                              <span class="page-text27" *ngIf="contact?.additionalAddress === null || contact?.additionalAddress === ''">----</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="page-container35">
                  <div class="page-container36">
                    <h3 class="page-text28">
                      <span>Informations générales</span>
                      <br />
                    </h3>
                    <div *ngIf="retrieveContactLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                    <div class="page-container37" *ngIf="!retrieveContactLoader">
                      <div class="page-container38">
                        <div class="page-container39">
                          <div class="page-container40">
                            <h4 class="page-text31">Le propriétaire du contact</h4>
                            <div class="page-container41">
                              <span class="page-text32" *ngIf="contact?.owner != null && contact?.owner !== ''">{{contact?.owner}}</span>
                              <span class="page-text32" *ngIf="!contact?.owner || contact?.owner === ''">----</span>
                            </div>
                          </div>
                          <div class="page-container42">
                            <h4 class="page-text33">Responsable hiérarchique</h4>
                            <div class="page-container43">
                              <span class="page-text34" *ngIf="contact?.hierarchicalSupervisor != null && contact?.hierarchicalSupervisor !== ''">{{contact?.hierarchicalSupervisor}}</span>
                              <span class="page-text34" *ngIf="!contact?.hierarchicalSupervisor || contact?.hierarchicalSupervisor === ''">----</span>
                            </div>
                          </div>
                        </div>
                        <div class="page-container44">
                          <div class="page-container45">
                            <h4 class="page-text35">Origine de la piste</h4>
                            <div class="page-container46">
                              <span class="page-text36" *ngIf="contact?.leadOrigin != null && contact?.leadOrigin !== ''">{{contact?.leadOrigin}}</span>
                              <span class="page-text36" *ngIf="!contact?.leadOrigin || contact?.leadOrigin === ''">----</span>
                            </div>
                          </div>
                          <div class="page-container47">
                            <h4 class="page-text37">Téléphone (autre)</h4>
                            <div class="page-container48">
                              <span class="page-text38" *ngIf="contact?.otherPhone != null && contact?.otherPhone !== ''">{{contact?.otherPhone}}</span>
                              <span class="page-text38" *ngIf="!contact?.otherPhone || contact?.otherPhone === ''">----</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="page-container49">
                        <div class="page-container50">
                          <div class="page-container51">
                            <h4 class="page-text39">Langue</h4>
                            <div class="page-container52">
                              <span class="page-text40" *ngIf="contact?.language != null && contact?.language !== ''">{{contact?.language}}</span>
                              <span class="page-text40" *ngIf="!contact?.language || contact?.language === ''">----</span>
                            </div>
                          </div>
                          <div class="page-container53">
                            <h4 class="page-text41">A quitter la société</h4>
                            <div class="page-container54">
                              <input type="checkbox" disabled [checked]="contact?.leaveCompany" class="page-checkbox" />
                            </div>
                          </div>
                        </div>
                        <div class="page-container55">
                          <div class="page-container56">
                            <h4 class="page-text42">Invalid contact</h4>
                            <div class="page-container57">
                              <input type="checkbox" disabled [checked]="contact?.invalidContact" class="page-checkbox1" />
                            </div>
                          </div>
                          <div class="page-container58">
                            <h4 class="page-text43">A garder</h4>
                            <div class="page-container59">
                              <input type="checkbox" disabled [checked]="contact?.keepContact" class="page-checkbox2" />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="page-container60">
                        <div class="page-container61">
                          <div class="page-container62">
                            <h4 class="page-text44">Description</h4>
                            <div class="page-container63">
                              <span class="page-text45" *ngIf="contact?.description != null && contact?.description !== ''">{{contact?.description}}</span>
                              <span class="page-text45" *ngIf="!contact?.description || contact?.description === ''">----</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              
        </div>
        <div class="d-flex justify-content-center">
          <a class="btn progress-button btn-rounded mb-2 pr-5 pl-5 mr-2" style="background-color: #b8bac9; color: black;" routerLink="/contacts" >
            Retour
          </a>
          <a type="button" class="btn btn-gradient-dark ml-2 mb-2 btn-rounded btn_new_customer" 
              [attr.href]="'edit-contact/'+contact?.uuid" >
              <i class="flaticon-pencil-1"></i> Modifier le contact
          </a>
      </div>
     </div>
  </div>